import "./MultiAccountEquityOrderDisplayComponent.scss";
import template from "./MultiAccountEquityOrderDisplayComponent.html";
import {IComponentOptions} from "angular";
import {EquityWizardData} from "../../../place-equity-order-wizard/models/EquityWizardData";

export const MultiAccountEquityOrderDisplay = "tfMultiAccountEquityOrderDisplay";

export function multiAccountEquityOrderDisplay(): IComponentOptions {
    return {
        template,
        bindings: {
            orders: "<"
        },
        controllerAs: "ctrl",
        controller: EquityOrderDisplayComponentController
    };
}

export class EquityOrderDisplayComponentController {
    /** @input */
    public readonly orders: EquityWizardData[];
}
